export { default } from './LookbookFirstElementTeaser';
